export default function CategorySelector({ categories, category, onCategoryChange }) {
  /**
   * Determina si una categoría está seleccionada en el radio button
   * 
   * @description Función optimizada que maneja la lógica de selección de categorías:
   * - Primera categoría (índice 0): se considera seleccionada cuando tanto el valor
   *   de la categoría como el estado actual están vacíos (categoría "Todas")
   * - Otras categorías: comparación directa entre valores normalizados
   * Normaliza los valores a string y elimina espacios para comparación segura.
   */
  const isSelected = (catValue, index) => {
    const normalizedCategory = String(category || '').trim();
    const normalizedCatValue = String(catValue || '').trim();
    
    // Primera categoría: seleccionada si ambas están vacías
    if (index === 0) {
      return normalizedCatValue === '' && normalizedCategory === '';
    }
    
    // Otras categorías: comparación directa
    return normalizedCatValue === normalizedCategory;
  };

  return (
    <div className="tags-container">
      {categories && categories.map((cat, index) => (
        <label key={cat.id + cat.value}>
          <input
            type="radio"
            name="category"
            value={cat.value}
            checked={isSelected(cat.value, index)}
            onChange={onCategoryChange}
          />
          <span className="tag-label">{cat.label}</span>
        </label>
      ))}
    </div>
  )
}